import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

function ForgotPasswordPage() {
    const [username, setUsername] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [step, setStep] = useState(1); // 1: Request Code, 2: Reset Password
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleRequestCode = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            await authService.forgotPassword(username);
            setStep(2);
            setMessage(`Verification code sent to email associated with ${username}`);
        } catch (err) {
            setError(err.message || "Failed to send verification code.");
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await authService.confirmPassword(username, code, newPassword);
            setMessage("Password reset successful! Redirecting to login...");
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (err) {
            setError(err.message || "Failed to reset password.");
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f5f7fa' }}>
            <div style={{ background: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
                <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '24px' }}>Reset Password</h2>

                {error && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' }}>{error}</div>}
                {message && <div style={{ background: '#dcfce7', color: '#166534', padding: '12px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' }}>{message}</div>}

                {step === 1 ? (
                    <form onSubmit={handleRequestCode}>
                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#4a5568', fontSize: '14px', fontWeight: '500' }}>Username</label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                style={{ width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '4px', outline: 'none', fontSize: '16px' }}
                                required
                            />
                        </div>
                        <button type="submit" style={{ width: '100%', padding: '12px', background: '#4299e1', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', transition: 'background 0.2s' }}>
                            Send Verification Code
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleResetPassword}>
                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#4a5568', fontSize: '14px', fontWeight: '500' }}>Verification Code</label>
                            <input
                                type="text"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                style={{ width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '4px', outline: 'none', fontSize: '16px' }}
                                placeholder="Enter code from email"
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#4a5568', fontSize: '14px', fontWeight: '500' }}>New Password</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                style={{ width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '4px', outline: 'none', fontSize: '16px' }}
                                required
                            />
                        </div>
                        <button type="submit" style={{ width: '100%', padding: '12px', background: '#4299e1', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', transition: 'background 0.2s' }}>
                            Reset Password
                        </button>
                    </form>
                )}

                <div style={{ marginTop: '16px', textAlign: 'center' }}>
                    <button
                        onClick={() => navigate('/login')}
                        style={{ background: 'none', border: 'none', color: '#718096', cursor: 'pointer', fontSize: '14px' }}
                    >
                        Back to Login
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordPage;
